import { render, staticRenderFns } from "./senior.vue?vue&type=template&id=97747fe0&scoped=true&"
import script from "./senior.vue?vue&type=script&lang=js&"
export * from "./senior.vue?vue&type=script&lang=js&"
import style0 from "./senior.vue?vue&type=style&index=0&lang=css&"
import style1 from "./senior.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./senior.vue?vue&type=style&index=2&id=97747fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97747fe0",
  null
  
)

export default component.exports